"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageStorageService = void 0;
const Common_1 = require("./Common");
class MessageStorageService {
    constructor() {
        this.approximateSize = 0;
        this.store = [];
    }
    static get THRESHOLD() {
        return Common_1.MAX_MESSAGE_STORAGE;
    }
    get empty() {
        return this.store.length === 0;
    }
    /**
     * Discards all currently stored message.
     */
    clear() {
        this.store = [];
        this.approximateSize = 0;
    }
    /**
     * Stores the current message. We will keep at least 1 message, and if the total approximate memory exceeds a threshold, we will discard the old event.
     * @param message
     */
    push(message) {
        this.approximateSize += JSON.stringify(message).length;
        this.store.push(message);
        if (this.store.length > 1 && this.approximateSize > MessageStorageService.THRESHOLD) {
            this.store.shift();
        }
    }
}
exports.MessageStorageService = MessageStorageService;
